import React from "react";

export default function Sticky({ children }) {
  return <div className="lg:sticky lg:top-6 space-y-8">{children}</div>;
}
